import SNotFound from "./SNotFound_web"
export default SNotFound
